import { Component } from '@angular/core';
import { assets } from '../../constants/assets.const';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mindbase-not-verified',
  standalone: true,
  imports: [TranslateModule],
  template: `
  <div class="ndf">
    <figure class="not-found">
      <img class="not-found-image" [src]="assetsConst.notVerified" alt="show icon" />
    </figure>
  </div>
`,
  styles: [
    `
    .ndf {
      text-align: center;
      .not-found-image {
        margin-top: 12%;
      }
    }
  `
  ]
})
export class NotVerifiedComponent {
  protected assetsConst = assets;
}
